import { render, staticRenderFns } from "./PayResult.vue?vue&type=template&id=0e6b4428&scoped=true&"
import script from "./PayResult.vue?vue&type=script&lang=js&"
export * from "./PayResult.vue?vue&type=script&lang=js&"
import style0 from "./PayResult.vue?vue&type=style&index=0&id=0e6b4428&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6b4428",
  null
  
)

export default component.exports